import { AppData, BookingData, Step } from "../../AppDataProvider";
import { CompleteDetailsStepPayload } from "../../actions";
import { emitBookingCreatedEvent } from "../../../utils/emitEvent/emitBookingCreatedEvent";
import { Mixpanel } from "../../../mixpanel";
import { PartRequired } from "../../../utils/types";

export type CompleteDetailsStepOptions = {
  appData: AppData;
  payload: CompleteDetailsStepPayload;
};

type CompleteDetailsStepBookingData = PartRequired<BookingData, "organisation">;

const getNextStepAfterDetails = (
  updatedBookingData: CompleteDetailsStepBookingData,
): Step => {
  if (
    updatedBookingData.confirmedBookingIds &&
    updatedBookingData.confirmedBookingIds?.length > 0
  ) {
    return "bookingCreated";
  }

  return "payments";
};

export const completeDetailsStep = (
  options: CompleteDetailsStepOptions,
): AppData => {
  Mixpanel.track({ name: "Completed step", props: { step: "details" } });

  const { bookingData } = options.appData;

  const updatedBookingData = {
    ...bookingData,
    ...options.payload.updatedData,
  } as CompleteDetailsStepBookingData;

  const currentStep = getNextStepAfterDetails(updatedBookingData);

  const updatedAppData: AppData = {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: currentStep,
  };

  emitBookingCreatedEvent(updatedAppData);

  return updatedAppData;
};
